import { render, staticRenderFns } from "./BatteryChargeLevel.vue?vue&type=template&id=6afd5769&"
import script from "./BatteryChargeLevel.vue?vue&type=script&lang=js&"
export * from "./BatteryChargeLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6afd5769')) {
      api.createRecord('6afd5769', component.options)
    } else {
      api.reload('6afd5769', component.options)
    }
    module.hot.accept("./BatteryChargeLevel.vue?vue&type=template&id=6afd5769&", function () {
      api.rerender('6afd5769', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/devices/devicedetail/batterychargelevel/BatteryChargeLevel.vue"
export default component.exports